import { create } from 'zustand';

type DeprecatedNodesState = {
  deprecatedNodeIds: Set<string>;
  setDeprecatedNodeIds: (ids: Set<string>) => void;
  addDeprecatedNodeId: (id: string) => void;
  removeDeprecatedNodeId: (id: string) => void;
  clearDeprecatedNodeIds: () => void;
};

export const useDeprecatedNodesStore = create<DeprecatedNodesState>(set => ({
  deprecatedNodeIds: new Set<string>(),

  setDeprecatedNodeIds: (ids: Set<string>) => {
    set(() => ({ deprecatedNodeIds: new Set(ids) }));
  },

  addDeprecatedNodeId: (id: string) => {
    set(state => ({
      deprecatedNodeIds: new Set([...state.deprecatedNodeIds, id]),
    }));
  },

  removeDeprecatedNodeId: (id: string) => {
    set(state => {
      const next = new Set(state.deprecatedNodeIds);
      next.delete(id);
      return { deprecatedNodeIds: next };
    });
  },

  clearDeprecatedNodeIds: () => {
    set(() => ({ deprecatedNodeIds: new Set<string>() }));
  },
}));
